import React, { useEffect, useState } from "react";
import "./truchamp.scss";
import { Image_Url } from "../../ImageUrl/ImageUrl"; // Replace with actual image paths

function TruChampDeepLink() {
  const [device, setDevice] = useState(null);
  const [showStoreButtons, setShowStoreButtons] = useState(false);

  useEffect(() => {
    // Detect device type
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      setDevice("android");
      attemptDeepLink("intent://truchamp/#Intent;scheme=https;package=com.tvs.tvs_pgm_prod;end");
    } else if (isIOS) {
      setDevice("ios");
      attemptDeepLink("truchamp://"); // iOS app scheme
    } else {
      setDevice("other");
      setShowStoreButtons(true); // Show store buttons for unsupported devices
    }
  }, []);

  // Attempt to open the app via deep link
  const attemptDeepLink = (deepLinkUrl) => {
    const timeout = setTimeout(() => {
      // If app is not installed, redirect to respective store
      if (device === "android") {
        window.location.href = "https://play.google.com/store/apps/details?id=com.tvs.tvs_pgm_prod";
      } else if (device === "ios") {
        window.location.href = "https://apps.apple.com/in/app/truchamp/id6447317410";
      }
    }, 1000); // Reduced timeout for better UX

    // Try to open the app
    window.location.href = deepLinkUrl;

    return () => clearTimeout(timeout);
  };

  // Handle manual store redirect (for buttons)
  const handleRedirectToStore = () => {
    if (device === "android") {
      window.location.href = "https://play.google.com/store/apps/details?id=com.tvs.tvs_pgm_prod";
    } else if (device === "ios") {
      window.location.href = "https://apps.apple.com/in/app/truchamp/id6447317410";
    }
  };

  // Only show the fallback UI if we're not automatically redirecting
  if (showStoreButtons || device === "other") {
    return (
      <div className="true-champ-container">
        <div className="true-champ">
          <img
            className="true-champ-logo"
            src={Image_Url.TruChamp}
            alt="TruChamp Logo"
          />
        </div>
        <div className="true-champ-button">
          <div className="truchamp-text">Get the app on your device:</div>
          <div className="download-buttons">
            <img
              src={Image_Url.DOWNLOAD_GOOGLE}
              alt="Download on Google Play"
              onClick={() => window.location.href = "https://play.google.com/store/apps/details?id=com.tvs.tvs_pgm_prod"}
              style={{ cursor: "pointer" }}
            />
            <img
              src={Image_Url.DOWNLOAD_APPPLE}
              alt="Download on App Store"
              onClick={() => window.location.href = "https://apps.apple.com/in/app/truchamp/id6447317410"}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </div>
    );
  }

  // Default view while attempting to open app
  return (
    <div className="true-champ-container">
      <div className="true-champ">
        <img
          className="true-champ-logo"
          src={Image_Url.TruChamp}
          alt="TruChamp Logo"
        />
      </div>
      <div className="true-champ-button">
        <h2>Launching TruChamp app...</h2>
      </div>
    </div>
  );
}

export default TruChampDeepLink;
